import Link from 'next/link'
import * as React from 'react'

type ErrorPageContentProps = {
  type: '404' | 'error'
}

export default function ErrorPageContent({ type }: ErrorPageContentProps) {
  const message =
    type === '404' ? 'Page Not Found :(' : 'Oh shame, there was an error :('
  const linkCopy = type === '404' ? 'Go Home' : 'Try going home?'
  return (
    <section className='flex items-center justify-center'>
      <div className='text-center'>
        <h1 className='p--large text-red mb-8'>{message}</h1>
        <p>
          <Link href='/' className='hover:text-blue underline'>
            {linkCopy}
          </Link>
        </p>
      </div>
    </section>
  )
}
